// extracted by mini-css-extract-plugin
export default {"tableRow":"challanList_tableRow__Q2kBa","tableCell":"challanList_tableCell__otdgY"};